/**
 * @file cart.service.ts
 */
import { Injectable } from '@angular/core';
import { Prescription } from '../../interfaces/prescription.interface';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  public isCart = false;

  public prescriptions: Prescription[] = [];

  constructor() { }
}
